import { Component, OnInit, Input } from '@angular/core';
import { WploginService } from 'src/app/services/wplogin.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { HttpService } from 'src/app/services/http.service';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-doctyp2',
  templateUrl: './doctyp2.component.html',
  styleUrls: ['./doctyp2.component.scss']
})
export class Doctyp2Component implements OnInit {

  @Input() Document: any;
  doi: any;
  pdf: string;
  access: boolean;

  today: number = Date.now();
  wellen = [];
  status = [];

  dateiname: string;
  dateien = [];

  constructor(
    private wplogin: WploginService,
    private router: Router,
    private snackBar: MatSnackBar,
    private http: HttpService,
  ) {


  }

  ngOnInit() {


    if (this.Document['2_st_wellen'] && this.Document['2_st_wellen'] !== undefined ) {
      this.Document['2_st_wellen'].forEach(element => {


        this.http.analyse(element['ID']).subscribe(analyse => {

            this.wellen.push(
              {
                title: element.content,
                link: analyse['_source']['LmAdd']['wellelnk']
              }
              );

            });

      });

     }


      this.wellen.sort((a, b) => a.title.localeCompare(b.title));




    this.access = this.wplogin.getLoginStatus();




    if (this.Document['2_Status']) {
      this.Document['2_Status'].forEach(element => {
        element['st_lyfecycleevent_entitaet'].forEach(element2 => {
            this.status.push(element2);
          });
        });
      console.log(this.status);
    }





    if (this.Document['2_Anhaenge']) {
      this.Document['2_Anhaenge'].forEach(item => {
        item['st_anhang_zugang'].forEach( element2 => {

        this.dateiname = '2_sourcename' + item.tf_datei;
        const link = this.Document[this.dateiname];

        if (item['st_anhang_typ']) {

            this.dateien.push(
              {
                cat: item['st_anhang_typ'],
                items: []
              }
            );

            if (this.dateien) {
              this.dateien.forEach(datei => {
                if (datei.cat === item['st_anhang_typ']) {
                  datei.items.push({
                    title: item.st_anhang_titel,
                    link: 'https://bolsa.uni-halle.de/wp-content/themes/graphy/app/assets/anhang/' + link,
                    freigabe: element2['ID'],
                  });
                }
              });
            }
          }
        });
      });
    }

    // delete dublicate objects
    this.dateien = this.dateien.filter((element, index, self) =>
      index === self.findIndex((t) => (
        t.cat === element.cat
      )));





    console.log(this.dateien);




  }


  link(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + id]));
  }

  copy2Clipboard() {
    const element = document.getElementById('copy-cit');
    element.innerHTML = element.innerText || element.textContent;

    const ta = document.createElement('textarea');
    ta.value = element.innerHTML;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);

    this.snackBar.open('In die Zwischenablage kopiert', 'schließen', {
      duration: 2000,
    });
  }

}
